import { VisibilityOutlined } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Facture from '../../../Components/Docs/Facture';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import {statutPaiementEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
// import { getLastWorkingDayOfMonth } from '../../../Utils/getCalendarMonthMatrix';
import { getNomPrenomClearFromPersoData, searchLabelInEnumByValue, sortDate, UpperCasePrenomNom } from '../../../Utils/utils';
import { getMontatantTTC } from '../../../Utils/utilsCraX';
import HeaderAllFacture from '../../Expert/Mission/HeaderAllFacture';

const AllRegularisationClient = () => {
    const { addEuro4Decimal } = useNumberFormatting();

    const navigate = useNavigate();
    const { setBackdropOpen} = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const [factureRows, setFactureRows] = useState([]);
    const [rowselected, setRowSelected] = useState();
    const [open, setOpen] = useState(false);
    const role=useRole();
    const [selectedRow, setSelectedRow] = React.useState(null);
    const { i18n } = useTranslation();
    const regularisationColumns4Client = [
        {
            field: 'refFactureClient',
            title: i18n.t('Réf. Facture'),
            render:  rowData => (
                <Button
                    variant='text'
                    onClick={()=> {
                        Promise.resolve().then(() => {
                            setRowSelected(rowData);
                            setOpen(true);
                        }).then(() => setOpen(true));
                    }}
                >
                    {rowData?.refFactureClient}
                </Button>
            )
        },
        {
            field: 'eye',
            title: i18n.t('Option'),
            render: rowData =>{
                return (
                    <IconButton
                        onClick={() => {
                            if(rowData?.isCraOrCraX=='craXId')
                                navigate(`/${role}/RegularizationPC`, {state: {rowData} });
                            else
                                navigate(`/${role}/NormalRegularization`, {state: {rowData} });
                        }}
                    >
                        <VisibilityOutlined />
                    </IconButton>
                );
            },
        },
        {
            field: 'dateEmission',
            title: i18n.t('Date d\'émission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateEmission),
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom de l\'expert'),
        },
        {
            field: 'refCra',
            title: i18n.t('Réf.CRA'),
        },
        {
            field: 'intituleMission',
            title: i18n.t('Intitulé de la mission'),
        },
        {
            field: 'statutPaiementClient',
            title: i18n.t('Statut paiement'),
        },
        {
            field: 'datePaiementClient',
            title: i18n.t('Date Paiement/Client'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.datePaiementClient)
        },
        {
            field: 'periode',
            title: i18n.t('Période'),
            //render:  rowData =>
            //    searchLabelInEnumByValue(MonthsString,(rowData?.periode)),
        },
        {
            field: 'dateEcheance',
            title: i18n.t('Date d\'échéance'),
        },
        {
            field: 'nbJour',
            title: i18n.t('Nb de jours'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJour,'j');
            }
        },
        {
            field: 'tjClientHt',
            title: i18n.t('Taux journalier HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjClientHt)
        },
        {
            field: 'totalHTClient',
            title: i18n.t('Total HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.totalHTClient)
        },
        {
            field: 'tvaClient',
            title: i18n.t('TVA appliquée'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tvaClient,' %'),
        },
        {
            field: 'totalTTCClient',
            title: i18n.t('Total TTC'),
            render:  rowData =>
                addEuro4Decimal(getMontatantTTC(rowData?.totalHTClient, rowData?.tvaClient)),
        },
        {
            field: 'respOperationnel',
            title: i18n.t('Resp.Opérationnel'),
        },
        {
            field: 'respAchat',
            title: i18n.t('Resp.Achat'),
        },
        {
            field: 'respComptabilite',
            title: i18n.t('Resp.Comptabilité'),
        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),
        },
    ];

    useEffect(() => {
        if(role)
            getMyRegularisations();
    }, [role]);

    //=============================================================================

    const getMyRegularisations = async () => {
        setBackdropOpen(true);
        const endpoint = role === 'esn'
            ? '/facture/getMyRegularisations/?isAchat=true'
            : '/facture/getMyRegularisations/';
        try {
            const response = await axiosPrivate.get(endpoint, {});

            let listRegularisation = await response.data;
            let Array1=[];
            listRegularisation?.forEach(regularisation => {
                const isCraOrCraX = regularisation?.nbrUnite ? 'craId' : 'craXId';
                Array1.push({
                    isCraOrCraX,
                    'id': regularisation?._id,
                    //'refFactureClient': regularisation?.nbrUnite ? regularisation?.regularisationId : regularisation?.regularisationXId,
                    'refFactureClient':regularisation?.refFacture,
                    'refCra': regularisation?.[isCraOrCraX]?.[isCraOrCraX],
                    'nomExpert': UpperCasePrenomNom(regularisation?.[isCraOrCraX]?.missionId?.expertId?.persoData),
                    'nomEsn':regularisation?.[isCraOrCraX]?.missionId?.esnId?.profileEntreprise?.nom,
                    'intituleMission': regularisation?.[isCraOrCraX]?.missionId?.titre,
                    'dateValidationCra': Date(regularisation?.[isCraOrCraX]?.DateVC) > Date(regularisation?.[isCraOrCraX]?.DateVE) ? formatDateJJMMYYYY(regularisation?.[isCraOrCraX]?.DateVC) : formatDateJJMMYYYY(regularisation?.[isCraOrCraX]?.DateVE),
                    'dateEmission': formatDateJJMMYYYY(regularisation?.dateEmission),
                    'Date':regularisation?.dateEmission, // champ spécifie le tri
                    'Statut': regularisation?.nbrUnite ? regularisation?.statutFacture : regularisation?.statutFactureX,
                    //'periode':regularisation?.[isCraOrCraX]?.month,
                    'periode':
                        dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('MMMM YYYY')
                    ,
                    'dateEcheance':formatDateJJMMYYYY(moment(regularisation?.dateEmission).add('days',regularisation?.delaiPaiement)),
                    // 'dateEcheance':formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                    //     dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                    //     dayjs(new Date(regularisation?.[isCraOrCraX]?.year, regularisation?.[isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                    //     (regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))).add('days',regularisation?.delaiPaiement)),
                    'statutPaiementClient':i18n.t(searchLabelInEnumByValue(statutPaiementEnum,regularisation?.statutPaimentClient)),
                    'datePaiementClient':regularisation?.datePaimentClient,
                    'nbJour':regularisation?.nbrUnite,
                    'tjClientHt':regularisation?.[isCraOrCraX]?.tjClient,
                    'tvaClient':regularisation?.tvaClient ?? regularisation?.[isCraOrCraX]?.missionId?.esnId?.donneeFacturation?.tauxTva ?? regularisation?.[isCraOrCraX]?.missionId?.companyDataId?.donneeFacturation?.tauxTva,

                    'hnos':regularisation?.hnos,
                    'astreintes':regularisation?.astreintes,
                    'notesFrais':regularisation?.notesFrais,

                    'totalAstreinte':regularisation?.totalAstreintes,
                    'totalHnoClient':regularisation?.totalHnosClient,
                    'totalHnoExpert': regularisation?.totalHnos,
                    'totalNotesFrais': regularisation?.totalNotesFrais,

                    'totalHTClient':regularisation?.montantTotalClient,

                    'respComptabilite':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.responsableComptabiliteId?.persoData  ?? regularisation?.[isCraOrCraX]?.bdcId?.responsableComptabiliteEsnId?.persoData),
                    'respOperationnel':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.responsableOperationnelId?.persoData  ?? regularisation?.[isCraOrCraX]?.bdcId?.responsableOperationnelEsnId?.persoData),
                    'respAchat':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.responsableAchatId?.persoData  ?? regularisation?.[isCraOrCraX]?.bdcId?.responsableAchatEsnId?.persoData),
                    'chargeRecrutement':getNomPrenomClearFromPersoData(regularisation?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData),
                    ...regularisation
                });
            });
            setFactureRows(sortDate(Array1));
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    return (
        <>
            {role === 'esn'
                ? (
                    <div className='frame5Profile'>
                        {i18n.t('CRA & Factures')}
                        &gt;
                        <span style={{ color: '#B0B0B0' }}>{i18n.t('Achat')}</span>
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Factures')}</span>
                    </div>
                )
                : (
                    <div className='frame5Profile'>
                        {i18n.t('CRA & Factures')}
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Factures')}</span>
                    </div>
                )
            }
            <div className='HomeFrame'>
                <h4 className='titlesociete'>
                    {i18n.t('Factures')}
                </h4>
                <HeaderAllFacture />
                <MaterialTableComponent
                    title={i18n.t('Factures')}
                    data={factureRows}
                    columns={regularisationColumns4Client}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                    }}
                    selectedRow={selectedRow}
                />
            </div>
            {open &&
            <Facture
                handleClose={()=>{
                    setOpen(false);
                }}
                facture={rowselected}
                open={open}
                role={'client'}
                regularisation={'true'}
            />}
        </>
    );
};

export default AllRegularisationClient;

